import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { SearchBar } from 'user/components'

import './style.css'

export default class PortalHeader extends Component {
  static propTypes = {
    companyName: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired
  }

  render () {
    return (
      <div className='portal-header-container'>
        <SearchBar />
        <div className='portal-header-logo-container'>
          <img className='portal-header-logo' src={this.props.logo} alt={this.props.companyName} />
        </div>
      </div>
    )
  }
}
